import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { layoutFor } from '../../lib/layout';
import { hideBackButton } from '../../lib/tma';
import { AppHeader } from './AppHeader';
import { TabBar } from './TabBar';

/**
 * Picks the chrome by path (spec 5.1): the five main screens get the header and
 * the bottom menu; step and plain screens bring their own layout.
 */
export function AppShell() {
  const { pathname } = useLocation();
  const tab = layoutFor(pathname) === 'tab';

  useEffect(() => {
    if (tab) hideBackButton();
  }, [tab, pathname]);

  if (!tab) return <Outlet />;
  return (
    <>
      <AppHeader />
      <main className="px-4 max-w-lg mx-auto pb-[calc(88px+env(safe-area-inset-bottom))]">
        <Outlet />
      </main>
      <TabBar />
    </>
  );
}
